import {BaseDto} from 'common';
import {RecentAccountActivitySubscriptionDto} from './recentAccountActivitySubscription.dto';

/**
 * reflects SubscriptionPaymentsHistoryDto dto on server
 */
export class SubscriptionPaymentsHistoryDto extends BaseDto {
    code: string;
    fullName: string;
    email: string;
    subscriptions: RecentAccountActivitySubscriptionDto[];

    public deserialize(input: any): this {
        Object.assign(this, input);

        this.subscriptions = this.deserializeArray(input.subscriptions, RecentAccountActivitySubscriptionDto);

        return this;
    }
}
